import React from 'react';

import './Divider.scss';

const Divider = () => {
  return <hr className="popup-context__divider" />;
};

export default Divider;
